import { languages } from "./languages";

export const defaultLanguage = "en-CA";

// export const defaultLanguage = "zh-CN";

export const UIText = languages[defaultLanguage];
